import React from 'react';

import '../../../assets/css/App.css';
import MainContent from "../../../components/mainContent/MainContent";
import UsuarioAdminItemLayout from './UsuarioAdminItemLayout';

export default function UsuarioAdminItem() {

    return (
        <MainContent
            titulo='Administración de Usuarios'
            component={<UsuarioAdminItemLayout />}
            noBackground
        />
    );
}